import { Fragment} from "react"
import type { TaxCodeType } from "../types"
import { Toggle } from "components/actions/Toggle"
import toast from "react-hot-toast"
import { useApi, useToggle } from "utils"


export function IsActive(props: {
    id: TaxCodeType
    refetch?: () => void
}) {
    // Hooks
    const api = useApi()
    const { isActive, toggle } = useToggle(props.id.is_deleted ?? false)

    const onSubmit = (value: TaxCodeType) => {
        return new Promise<void>((resolve) => {
            toggle()
            toast.promise(
                api.put("/taxcode/changestatus",
                    {
                        tax_id: value.tax_id,
                        taxdel: !isActive
                    }),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            ).then(() => {
                if (props.refetch) {
                    props.refetch()
                }
            }).catch(() => {
                toggle()
            }).finally(resolve)
        })
    }

    return (
        <Fragment>
            <Toggle
                label="Soft Delete"
                isChecked={isActive} 
                onClick={() => {
                    onSubmit(props.id);
                }} />
        </Fragment>
    )
}